const NS = 'WysiwygBlock';
const CLS = 'wysiwygBlock';

import { imageViewerModal } from '../../../../global/js/wool/imageViewerModal';

export class WysiwygBlock {
	constructor(element) {
		this.element = element;
		this.$element = $(element);
		this.initImageOverride();
		this.initResponsiveTables();
		this.initListOverride();
	}

	initImageOverride() {
		this.$images = this.$element.find('> p > img, > img');
		this.$images.each((index, element) => {
			let cssClass;
			// Float left property
			if($(element).css('float') === 'left') {
				cssClass = 'float-left';
			}
			// Float right
			else if($(element).css('float') === 'right') {
				cssClass = 'float-right';
			}
			// Align center (block implies center block alignment)
			else if($(element).css('display') == 'block') {
				cssClass = 'align-center';
			}

			$(element).wrap(`<div class='image-wrap ${cssClass}'></div>`);

			let $imageWrap = $(element).parent('.image-wrap');
			$imageWrap.css({
				width: `${$(element).width()}`
			});

			$(element).css({
				float: 'unset',
				display: 'inline-block'
			});

			imageViewerModal.init($imageWrap);
		});
	}

	// Wrap a div.table-responsive class to have responsive tables
	initResponsiveTables() {
		this.$element.find('table').wrap(`<div class='table-responsive'></div>`).before('<div class="table-spacer"></div>').after('<div class="table-spacer"></div>');
	}

	initListOverride() {
		this.$element.find('ul > li').each((index, element) => {
			if(!$(element).find('ul').length > 0) {
				$(element).addClass('styled');
			}
		});

		this.$element.find('ol > li').each((index, element) => {
			if(!$(element).find('ol').length > 0) {
				$(element).addClass('styled');
			}
		});
	}
}
